export default function isReadonlyOverloadingAdj(adjReason) {
  if (!adjReason || typeof adjReason !== 'string') {
    return false
  }

  return adjReason.trim() === 'Overloaded'
}
